/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_u5_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why is my 5-minute WPM lower than my 1-minute WPM?`)
};

const es_typing_u5_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué mi WPM de 5 minutos es más bajo que mi WPM de 1 minuto?`)
};

const de_typing_u5_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum ist meine 5-Minuten-WPM niedriger als meine 1-Minuten-WPM?`)
};

const nl_typing_u5_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom is mijn WPM over 5 minuten lager dan mijn WPM over 1 minuut?`)
};

const fr_typing_u5_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi mon WPM sur 5 minutes est-il plus bas que mon WPM sur 1 minute ?`)
};

const it_typing_u5_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché il mio WPM da 5 minuti è più basso del mio WPM da 1 minuto?`)
};

const pt_br2_typing_u5_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que meu WPM de 5 minutos é menor que meu WPM de 1 minuto?`)
};

const pt_typing_u5_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que o meu WPM de 5 minutos é mais baixo do que o meu WPM de 1 minuto?`)
};

const ja_typing_u5_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜ5分間のWPMが1分間のWPMより低くなるのですか？`)
};

const zh_typing_u5_faq3_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么我的5分钟WPM比1分钟WPM低？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_u5_faq3_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_u5_faq3_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_u5_faq3_q", locale)
	if (locale === "en") return en_typing_u5_faq3_q(inputs)
	if (locale === "es") return es_typing_u5_faq3_q(inputs)
	if (locale === "de") return de_typing_u5_faq3_q(inputs)
	if (locale === "nl") return nl_typing_u5_faq3_q(inputs)
	if (locale === "fr") return fr_typing_u5_faq3_q(inputs)
	if (locale === "it") return it_typing_u5_faq3_q(inputs)
	if (locale === "pt-BR") return pt_br2_typing_u5_faq3_q(inputs)
	if (locale === "pt") return pt_typing_u5_faq3_q(inputs)
	if (locale === "ja") return ja_typing_u5_faq3_q(inputs)
	return zh_typing_u5_faq3_q(inputs)
};